<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Actualizar grupo o permiso</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="UPDATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar cambios</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="w-100" v-if="loading">
                    <div class="text-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="container-fluid max-w-screen-md vstack gap-3" v-else>
                    <div>
                        <label class="input-title">Nombre</label>
                        <label class="form-control form-control-sm readonly">{{  data.name }}</label>
                    </div>
                    <div>
                        <label class="input-title">Icono</label>
                        <input type="text" class="form-control form-control-sm" v-model="data.icon" :class="errors.icon ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.icon" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Visible en el menu</small>
                        <v-select v-model="data.view"
                            :items="views"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.view ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.view" :key="index">{{ error }}</small>
                    </div>
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default{
    data(){
        return{
            data: {},
            errors: {},
            count: 0,
            id: this.$route.params.id,
            loading: true,
            views: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
        }
    },
    mounted() {
        this.INIT()
    },
    methods: {
        INIT: function () {
            let vue = this
            axios({ url: '/permissions/' + vue.id, method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = false
                })
        },
        UPDATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                axios({url: '/permissions/' + vue.id, method: 'PUT', data: vue.data })
                .then((resp) => {
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    vue.$router.push({ name: 'PermissionIndex' })
                })
                .catch((err) => {
                    if(err.response.status === 422){
                        vue.errors = err.response.data
                    }else if(err.response.status === 402){
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }else{
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp)=>{
                    vue.count = 0
                })
            }
        }
    }
}
</script>